import { Component, Input, forwardRef } from '@angular/core'
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms'

@Component({
   selector: 'vc-checkbox',
   templateUrl: './checkbox.component.html',
   styleUrls: ['./checkbox.component.scss'],
   standalone: false,
   providers: [
      {
         provide: NG_VALUE_ACCESSOR,
         useExisting: forwardRef(() => VcCheckboxComponent),
         multi: true,
      },
   ],
})
export class VcCheckboxComponent implements ControlValueAccessor {
   @Input() label = ''
   @Input() disabled = false
   @Input() inputId?: string
   @Input() required = false

   value = false
   onChange = (_: any) => {}
   onTouched = () => {}

   writeValue(v: any) {
      this.value = !!v
   }
   registerOnChange(fn: any) {
      this.onChange = fn
   }
   registerOnTouched(fn: any) {
      this.onTouched = fn
   }
   setDisabledState(isDisabled: boolean) {
      this.disabled = isDisabled
   }
   toggleValue(): void {
      if (this.disabled) return
      this.value = !this.value
      this.onChange(this.value)
   }

   handleCheckboxChange(checked: boolean): void {
      this.value = checked
      this.onChange(checked)
   }
}
